import { useEffect, useCallback, useState } from 'react'
import AuthLayout from '@/layout/AuthLayout'
import Input from '@/components/general/Input/Input'
import Button from '@/components/general/Button/Button'
import styles from '@/styles/signin.module.scss'
import Link from 'next/link'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { login } from '@/service/auth.api'
import FormProvider, { useFormContext } from '@/context/form-context'
import LoadingWithWrapper from '@/components/general/loading/with-wrapper/LoadingWithWrapper'
import { useSnackBar } from '@/context/app-context'
import { useAuthContext } from '@/context/auth-context'

// import ConfirmModal from '~/components/general/modal/confirm-modal/ConfirmModal'

export default function SignInWithFormProvider() {
  return (
    <FormProvider>
      <SignIn />
    </FormProvider>
  )
}

export function SignIn() {
  const router = useRouter()
  const LANG = router.locale
  const [loading, setLoading] = useState(false)
  const { setIsAuthReady } = useAuthContext()
  const snackbar = useSnackBar()
  const {
    values, handleChange, errors, validateForm, setSchema, isFormValid, setIsFormValid
  } = useFormContext()

  useEffect(() => {
    const formSchema = [
      {
        field: 'email',
        displayName: 'Email',
        required: true
      },
      {
        field: 'password',
        displayName: 'Password',
        required: true
      }
    ]
    setSchema(formSchema)
  }, [setSchema])

  const signin = useCallback(async () => {
    setLoading(true)
    setIsAuthReady(false)
    try {
      const response = await login({
        email: values.email.trim(),
        password: values.password.trim()
      })
      localStorage?.setItem('token', response.data.login.jwt)
      localStorage?.setItem('profile', JSON.stringify(response.data.login.user))
      snackbar({
        content: 'เข้าสู่ระบบสำเร็จ',
        type: 'success'
      })
      const afterLogin = '/dashboard/my-product'
      router.push(afterLogin)
    } catch {
      snackbar({
        content: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง'
      })
    } finally {
      setLoading(false)
    }
  }, [values, snackbar, router, setIsAuthReady])

  useEffect(() => {
    if (isFormValid) {
      setIsFormValid(false)
      signin()
    }
  }, [isFormValid, signin, setIsFormValid])

  return (
    <>
      <Head>
        <title>
          Expert - Watch Repair Center |
          {' '}
          {LANG === 'th' ? 'เข้าสู่ระบบ' : 'Sign In'}
        </title>
      </Head>
      <h1 className={styles.heading}>{LANG === 'th' ? 'เข้าสู่ระบบ' : 'Sign In'}</h1>
      {loading && <LoadingWithWrapper />}
      {/* <ConfirmModal isOpen title="Confirm TTT" subTitle="please confirm" /> */}
      <Input
        label="Email"
        value={values.email || ''}
        name="email"
        onChange={handleChange}
        wrapperProps={{
          stylingClass: styles.input
        }}
        errorText={!!errors.email && errors.email}
      />
      <Input
        label="Password"
        type="password"
        name="password"
        value={values.password || ''}
        onChange={handleChange}
        wrapperProps={{
          stylingClass: styles.input
        }}
        errorText={!!errors.password && errors.password}
      />
      <Link href="/forgot-password">
        <a href="/forgot-password" className={styles.forgot}>
          {LANG === 'th' ? 'ลืมรหัสผ่าน' : 'Forgot Password?'}
        </a>
      </Link>
      <Button onClick={validateForm}>
        LOGIN
      </Button>
      <div className={styles.signup}>
        {LANG === 'th' ? 'ยังไม่มีบัญชี?' : 'Haven\'t got an account?'}
        <Link href="/signup">
          <a href="/signup">
            {' '}
            {LANG === 'th' ? 'สมัครสมาชิก' : 'Sign Up'}
          </a>
        </Link>
      </div>
    </>
  )
}
